<template>
  <Teleport to="body">
    <transition name="slide-right">
      <div v-if="isOpen" class="ai-panel">
        <div class="ai-header">
          <div class="ai-title">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 2a4 4 0 014 4v1a3 3 0 013 3v1a3 3 0 01-1 2.24V16a4 4 0 01-4 4h-4a4 4 0 01-4-4v-2.76A3 3 0 015 11v-1a3 3 0 013-3V6a4 4 0 014-4z"/>
            </svg>
            <span>AI 助手</span>
          </div>
          <button class="close-btn" @click="close">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <div class="ai-content" ref="contentRef">
          <div v-if="!messages.length" class="ai-welcome">
            <div class="welcome-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2a4 4 0 014 4v1a3 3 0 013 3v1a3 3 0 01-1 2.24V16a4 4 0 01-4 4h-4a4 4 0 01-4-4v-2.76A3 3 0 015 11v-1a3 3 0 013-3V6a4 4 0 014-4z"/>
              </svg>
            </div>
            <h3>你好，我是AI助手</h3>
            <p>我可以帮你：</p>
            <ul class="feature-list">
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 21l-4.35-4.35"/>
                </svg>
                <span>智能搜索网站和工具</span>
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="16,18 22,12 16,6"/>
                  <polyline points="8,6 2,12 8,18"/>
                </svg>
                <span>推荐编程资源和文档</span>
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>
                </svg>
                <span>提供在线工具建议</span>
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2v10z"/>
                </svg>
                <span>回答技术问题</span>
              </li>
            </ul>
          </div>

          <div v-else class="ai-messages">
            <div
              v-for="(msg, index) in messages"
              :key="index"
              class="message"
              :class="msg.role"
            >
              <div class="message-avatar">
                <svg v-if="msg.role === 'assistant'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2a4 4 0 014 4v1a3 3 0 013 3v1a3 3 0 01-1 2.24V16a4 4 0 01-4 4h-4a4 4 0 01-4-4v-2.76A3 3 0 015 11v-1a3 3 0 013-3V6a4 4 0 014-4z"/>
                </svg>
                <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </div>
              <div class="message-content">
                <div class="message-text" v-html="formatMessage(msg.content)"></div>
                <div v-if="msg.suggestions" class="message-suggestions">
                  <button
                    v-for="suggestion in msg.suggestions"
                    :key="suggestion"
                    @click="sendMessage(suggestion)"
                  >
                    {{ suggestion }}
                  </button>
                </div>
              </div>
            </div>

            <div v-if="isLoading" class="message assistant">
              <div class="message-avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2a4 4 0 014 4v1a3 3 0 013 3v1a3 3 0 01-1 2.24V16a4 4 0 01-4 4h-4a4 4 0 01-4-4v-2.76A3 3 0 015 11v-1a3 3 0 013-3V6a4 4 0 014-4z"/>
                </svg>
              </div>
              <div class="message-content">
                <div class="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ai-input-area">
          <div class="quick-actions">
            <button @click="quickAction('推荐一些前端学习资源')">
              前端资源
            </button>
            <button @click="quickAction('有哪些好用的在线工具')">
              在线工具
            </button>
            <button @click="quickAction('推荐AI编程助手')">
              AI工具
            </button>
          </div>
          <div class="input-wrapper">
            <input
              v-model="inputText"
              type="text"
              placeholder="输入你的问题..."
              @keydown.enter="handleSend"
            />
            <button class="send-btn" @click="handleSend" :disabled="!inputText.trim() || isLoading">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="22" y1="2" x2="11" y2="13"/>
                <polygon points="22,2 15,22 11,13 2,9 22,2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script setup>
import { ref, nextTick, onMounted, onUnmounted } from 'vue'
import { useNavStore } from '@/stores/nav'

const navStore = useNavStore()
const isOpen = ref(false)
const inputText = ref('')
const messages = ref([])
const isLoading = ref(false)
const contentRef = ref(null)

const aiResponses = {
  '前端': {
    content: '这里是一些优秀的前端学习资源：\n\n1. **MDN Web Docs** - Web技术权威文档\n2. **Vue.js官方文档** - Vue框架学习\n3. **React官方文档** - React框架学习\n4. **freeCodeCamp** - 免费编程课程\n5. **CSS-Tricks** - CSS技巧和教程',
    suggestions: ['Vue还是React好？', '推荐CSS学习资源', '有没有JavaScript进阶教程']
  },
  '工具': {
    content: '推荐一些实用的在线工具：\n\n1. **Regex101** - 正则表达式测试\n2. **Carbon** - 代码截图美化\n3. **TinyPNG** - 图片压缩\n4. **Excalidraw** - 手绘风格白板\n5. **draw.io** - 流程图绘制',
    suggestions: ['有没有JSON格式化工具', '推荐代码分享平台', '图片处理工具']
  },
  'AI': {
    content: '以下是主流的AI编程助手：\n\n1. **GitHub Copilot** - AI代码补全\n2. **ChatGPT** - 通用AI对话\n3. **Claude** - Anthropic的AI助手\n4. **Cursor** - AI代码编辑器\n5. **Perplexity** - AI搜索引擎',
    suggestions: ['Copilot如何使用', 'ChatGPT和Claude哪个好', 'AI写代码靠谱吗']
  },
  'default': {
    content: '我可以帮你查找网站、推荐资源或回答技术问题。请告诉我你想了解什么？',
    suggestions: ['推荐编程学习资源', '有哪些好用的工具', '介绍一下AI助手']
  }
}

function open() {
  isOpen.value = true
}

function close() {
  isOpen.value = false
}

function quickAction(text) {
  sendMessage(text)
}

function handleSend() {
  if (!inputText.value.trim() || isLoading.value) return
  sendMessage(inputText.value)
  inputText.value = ''
}

async function sendMessage(text) {
  messages.value.push({
    role: 'user',
    content: text
  })

  scrollToBottom()
  isLoading.value = true

  await new Promise(resolve => setTimeout(resolve, 800 + Math.random() * 700))

  let response = aiResponses['default']
  for (const [key, value] of Object.entries(aiResponses)) {
    if (key !== 'default' && text.includes(key)) {
      response = value
      break
    }
  }

  messages.value.push({
    role: 'assistant',
    content: response.content,
    suggestions: response.suggestions
  })

  isLoading.value = false
  scrollToBottom()
}

function formatMessage(content) {
  return content
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\n/g, '<br>')
}

function scrollToBottom() {
  nextTick(() => {
    if (contentRef.value) {
      contentRef.value.scrollTop = contentRef.value.scrollHeight
    }
  })
}

function handleGlobalKeydown(e) {
  if ((e.metaKey || e.ctrlKey) && e.key === 'i') {
    e.preventDefault()
    if (isOpen.value) {
      close()
    } else {
      open()
    }
  }
}

onMounted(() => {
  document.addEventListener('keydown', handleGlobalKeydown)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleGlobalKeydown)
})

defineExpose({ open, close })
</script>

<style lang="scss" scoped>
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform var(--transition-base), opacity var(--transition-base);
}

.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.ai-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  max-width: 100vw;
  height: 100vh;
  background: var(--bg-secondary);
  border-left: 1px solid var(--border-color);
  box-shadow: var(--shadow-xl);
  z-index: 1500;
  display: flex;
  flex-direction: column;
}

.ai-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md) var(--spacing-lg);
  border-bottom: 1px solid var(--border-color);
}

.ai-title {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: var(--text-lg);
  font-weight: 600;
  
  svg {
    width: 24px;
    height: 24px;
    color: var(--primary);
  }
}

.close-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  transition: all var(--transition-fast);
  
  svg {
    width: 18px;
    height: 18px;
  }
  
  &:hover {
    background: var(--bg-hover);
    color: var(--text-primary);
  }
}

.ai-content {
  flex: 1;
  overflow-y: auto;
  padding: var(--spacing-lg);
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: var(--border-color);
    border-radius: 3px;
  }
}

.ai-welcome {
  text-align: center;
  padding: var(--spacing-xl) 0;
}

.welcome-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto var(--spacing-lg);
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-light) 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 40px;
    height: 40px;
    color: white;
  }
}

.ai-welcome h3 {
  font-size: var(--text-xl);
  margin-bottom: var(--spacing-sm);
}

.ai-welcome p {
  color: var(--text-muted);
  margin-bottom: var(--spacing-md);
}

.feature-list {
  text-align: left;
  max-width: 280px;
  margin: 0 auto;
  
  li {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    padding: var(--spacing-sm) 0;
    color: var(--text-secondary);
    
    svg {
      width: 18px;
      height: 18px;
      color: var(--primary);
      flex-shrink: 0;
    }
  }
}

.ai-messages {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.message {
  display: flex;
  gap: var(--spacing-sm);
  
  &.user {
    flex-direction: row-reverse;
    
    .message-content {
      background: var(--primary);
      color: white;
    }
  }
  
  &.assistant {
    .message-content {
      background: var(--bg-tertiary);
    }
  }
}

.message-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  svg {
    width: 18px;
    height: 18px;
    color: var(--text-muted);
  }
}

.message-content {
  max-width: 80%;
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-lg);
}

.message-text {
  font-size: var(--text-sm);
  line-height: 1.6;
  
  strong {
    color: var(--primary);
  }
}

.message-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-xs);
  margin-top: var(--spacing-sm);
  
  button {
    font-size: var(--text-xs);
    padding: var(--spacing-xs) var(--spacing-sm);
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-full);
    color: var(--text-secondary);
    transition: all var(--transition-fast);
    
    &:hover {
      border-color: var(--primary);
      color: var(--primary);
    }
  }
}

.typing-indicator {
  display: flex;
  gap: 4px;
  padding: 4px 0;
  
  span {
    width: 8px;
    height: 8px;
    background: var(--text-muted);
    border-radius: 50%;
    animation: typing 1.4s infinite ease-in-out;
    
    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
}

@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  30% {
    transform: translateY(-4px);
    opacity: 1;
  }
}

.ai-input-area {
  padding: var(--spacing-md);
  border-top: 1px solid var(--border-color);
}

.quick-actions {
  display: flex;
  gap: var(--spacing-xs);
  margin-bottom: var(--spacing-sm);
  overflow-x: auto;
  padding-bottom: var(--spacing-xs);
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  button {
    flex-shrink: 0;
    font-size: var(--text-xs);
    padding: var(--spacing-xs) var(--spacing-sm);
    background: var(--bg-tertiary);
    border-radius: var(--radius-full);
    color: var(--text-secondary);
    transition: all var(--transition-fast);
    
    &:hover {
      background: var(--primary);
      color: white;
    }
  }
}

.input-wrapper {
  display: flex;
  gap: var(--spacing-sm);
  
  input {
    flex: 1;
    padding: var(--spacing-sm) var(--spacing-md);
    background: var(--bg-tertiary);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-lg);
    color: var(--text-primary);
    
    &::placeholder {
      color: var(--text-muted);
    }
    
    &:focus {
      border-color: var(--primary);
    }
  }
}

.send-btn {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary);
  border-radius: var(--radius-lg);
  color: white;
  transition: all var(--transition-fast);
  
  svg {
    width: 20px;
    height: 20px;
  }
  
  &:hover:not(:disabled) {
    background: var(--primary-dark);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
